import React, { useState } from "react";
import { PageHeader, Tabs } from "./hrComponents";
import { pageStyle } from "./hrUi";
import AccessTab from "./settings/AccessTab";
import DocumentSetupTab from "./settings/DocumentSetupTab";
import GeneralTab from "./settings/GeneralTab";
import HolidaysTab from "./settings/HolidaysTab";
import LeaveSetupTab from "./settings/LeaveSetupTab";
import OrganisationTab from "./settings/OrganisationTab";
import TimeSetupTab from "./settings/TimeSetupTab";
import WorkflowsTab from "./settings/WorkflowsTab";

// HR admins only (see HrGate permission="HR_ADMIN"). The tabs follow the order things are set up in:
// country first, then the organisation, leave and holidays, time (shifts, attendance, overtime), who approves what, documents, and who has access.
const TABS = [
  { key: "general", label: "General", render: () => <GeneralTab /> },
  { key: "organisation", label: "Organisation", render: () => <OrganisationTab /> },
  { key: "leave", label: "Leave", render: () => <LeaveSetupTab /> },
  { key: "holidays", label: "Holidays", render: () => <HolidaysTab /> },
  { key: "time", label: "Time", render: () => <TimeSetupTab /> },
  { key: "workflows", label: "Approvals", render: () => <WorkflowsTab /> },
  { key: "documents", label: "Documents & letters", render: () => <DocumentSetupTab /> },
  { key: "access", label: "Access & fields", render: () => <AccessTab /> },
];

export default function HrSettings() {
  const [tab, setTab] = useState("general");
  const active = TABS.find((t) => t.key === tab);
  return (
    <div style={pageStyle}>
      <PageHeader title="HR Settings" subtitle="Set up your company once; everything else in HR builds on it" />
      <Tabs tabs={TABS.map(({ key, label }) => ({ key, label }))} active={tab} onChange={setTab} />
      {active.render()}
    </div>
  );
}
